import React from "react";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import Loader from "react-loader";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
// import ReCAPTCHA from 'react-google-recaptcha';
import Amplify, { Auth, Analytics } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import * as SecretKeys from "../../ENV.json";
import {
  requestApiData,
  logoutUser,
  clearDataEmail,
  clearSignupData,
  setPageName
} from "../../Actions/actions";
import TextFieldGroup from "../common/TextFieldGroup";
import Header from "../Header/header";
// import { fusebillSaveCustomerIdToDB } from '../../Api/api';
const applicationUrl = SecretKeys.REACT_APP_FRONTEND_URL;

Amplify.configure(SecretKeys.awsUserpool);

Analytics.disable();
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errors: {},
      isLoading: false,
      // IsCaptchaTrue: false,
      failedLoginMessages: "",
      flagSetting: false,
      loaded: true,
      intervalId: 0
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    // this.onCatchaChange = this.onCatchaChange.bind(this);
    Auth.signOut();
  }

  componentDidUpdate() {
    // this.state.flagSetting = false;
    const loginStatus = localStorage.getItem("loginStatus");
    const roleName = localStorage.getItem("roleName");
    if (roleName === "Consumer" || roleName === "Business-User") {
      if (loginStatus === "error") {
        this.context.router.history.push("/profile-terms");
      }
    }
  }

  componentDidMount() {

    this.props.clearSignupData();

    // localStorage.setItem('changePlan', false)

    // localStorage.clear();
    // window.localStorage.clear();
    localStorage.removeItem("persist:root");
    // if (this.state.flagSetting) {
    //   this.setState({ flagSetting: false });
    // }
  }

  componentWillMount() {
    this.props.clearSignupData();
    // localStorage.clear();

    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId
    });
  }

  componentWillUnmount() {
    this.setState({
      email: "",
      password: "",
      errors: {},
      isLoading: false,
      // IsCaptchaTrue: false,
      failedLoginMessages: ""
    });
  }

  onChange(e) {
    this.setState({ errors: {}, failedLoginMessages: "" });
    this.setState({ [e.target.name]: e.target.value });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  validateInput(data) {
    const errors = {};
    if (Validator.isEmpty(data.email)) {
      errors.email = "Email is Required";
      errors.emailError = true;
    }
    if (data.email !== "") {
      if (!Validator.isEmail(data.email)) {
        errors.email = "Email is Not Valid";
        errors.emailError = true;
      }
    }
    if (Validator.isEmpty(data.password)) {
      errors.password = "Password is Required";
      errors.passwordError = true;
    }
    const re = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    if (data.password !== "") {
      if (!re.test(data.password)) {
        errors.password = "Password is Not Valid";
        errors.passwordError = true;
      }
    }

    // if (!data.IsCaptchaTrue) {
    //   errors.captcha = 'Captcha is Not validated';
    //   errors.captchaError = true;
    // }

    return {
      errors,
      isValid: isEmpty(errors)
    };
  }

  handleSubmit(e) {
    const { setPageName } = this.props

    e.preventDefault();
    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true, loaded: false });
      localStorage.clear();
      Auth.signOut()
        .then(() => {
          Auth.signIn(this.state.email.toLowerCase(), this.state.password)
            .then(user => {
              const jwtToken = user.signInUserSession.accessToken.jwtToken;
              const postInfo = {
                email: this.state.email.toLowerCase(),
                token: jwtToken,
                user,
                url: `${applicationUrl}/service-agreement/`
              };
              this.props.requestApiData(postInfo);
              setPageName("login")
            })
            .catch(error => {
              this.setState({
                failedLoginMessages: error.message,
                isLoading: false
              });
              if (error.message === "User is not confirmed.") {
                this.context.router.history.push("/verify-code");
              }
            });
        })
        .catch(error => error);
      /* Auth.signIn(this.state.email, this.state.password).then((user)=>{
                let jwtToken = user.signInUserSession.accessToken.jwtToken;
                let postInfo = {
                    "email":this.state.email,
                    "token":jwtToken,
                    user
                };
                this.props.requestApiData(postInfo);
            }).catch((error)=> {
              this.setState({failedLoginMessages:error.message})
                if(error.message==="User is not confirmed."){

                    this.context.router.history.push('/verify-code')
                }

            }); */
    }
  }

  // onCatchaChange(value) {
  //   if (value !== '') {
  //     this.setState({ IsCaptchaTrue: true });
  //   }
  // }

  async componentWillReceiveProps(nextProps) {
    const isOk = nextProps.data.userInfo;
    if (isOk.code === 200) {
      if (
        nextProps.data.userInfo.roleName === "Business-User" &&
        nextProps.data.userInfo.userObject.planDto &&
        nextProps.data.userInfo.userObject.planDto.planName !== "Basic" &&
        nextProps.data.userInfo.userObject.planDto.planName !==
        "Basic Automatic" &&
        nextProps.data.userInfo.userObject.planPriceDtos.connectFusebill !== 0
      ) {
        // Check if the payment status of the user is pending---------
        if (nextProps.data.userInfo.userObject.userDto.paymentStatus === "pending") {
          this.context.router.history.push("/add-payment-method");
          return;
        }
      }

      // New Parent Partner dashboard code

      // const { router } = this.context;
      // const userObject = JSON.parse(localStorage.getItem("userObject"));
      // const roleName = localStorage.getItem("roleName");
      // if (roleName === "Affiliate" || roleName === "Affiliate-SubUser") {
      //   if(userObject.userDto.parentAffiliateUser === "Yes"){
      //     router.history.push("/parent-affiliate");
      //   }else{
      //     router.history.push("/affiliate");
      //   }
      // } else if (localStorage.getItem("paymentStatus") === "paid") {
      //   this.context.router.history.push("/dashboard");
      // }

      const roleName = localStorage.getItem("roleName");
      if (roleName === "Affiliate" || roleName === "Affiliate-SubUser") {
        this.context.router.history.push("/affiliate");
      } else if (localStorage.getItem("paymentStatus") === "paid") {
        this.context.router.history.push("/dashboard");
      }
      //
    }

    if (isOk.code === 400) {
      const failedLoginMessages = isOk.error.message;
      this.setState({
        failedLoginMessages
      });
    }
    if (isOk.code === 400 && isOk.error.message === undefined) {
      const failedLoginMessages = isOk.error;
      this.setState({
        failedLoginMessages
      });
    }
    this.setState({ loaded: true, isLoading: false });
  }

  render() {
    const {
      errors,
      email,
      password,
      failedLoginMessages,
      flagSetting,
      isLoading
    } = this.state;
    // let data = this.props.data;
    // console.log('this.state.loaded',this.state.isLoading)
    if (flagSetting) {
      return (
        <span>
          <div className="container">
            <div className="main-content">
              <Header />
              <Loader loaded={this.state.loaded} />
              <div className="section-content center-align login-content">
                <h2>Login to Collectively</h2>
                <div className="row  error-message">
                  <form
                    className="col s12 m8 offset-m2 "
                    onSubmit={this.handleSubmit}
                  >
                    <div className="col s12">
                      {" "}
                      <span className="show invalid">
                        {failedLoginMessages}{" "}
                      </span>
                    </div>
                    <div className="row">
                      <div className="input-field col s12 custom-select">
                        <TextFieldGroup
                          field="email"
                          label="Username / Email"
                          value={email}
                          error={errors.email}
                          onChange={this.onChange}
                        />
                      </div>
                      <div className="input-field col s12">
                        <TextFieldGroup
                          field="password"
                          label="Password"
                          value={password}
                          error={errors.password}
                          onChange={this.onChange}
                          type="password"
                        />
                        <div className="forgot-psw">
                          <Link to="/reset-password">Forgot Password?</Link>
                        </div>
                      </div>
                      {/* <div className="col s12">
                        <div className="recapcha z-depth-2">
                          {' '}
                          <ReCAPTCHA
                            ref="recaptcha"
                            sitekey={SecretKeys.CaptchKeys}
                            onChange={this.onCatchaChange}
                          />
                          <span className={(errors.captchaError ? 'show invalid' : 'hide')}>{errors.captcha}</span>
                        </div>
                      </div> */}
                      <div className="col s12">
                        <button
                          className="btn waves-effect waves-light primary-btn col  s12 m6 offset-m3"
                          type="submit"
                          name="action"
                        >
                          Login
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                      <div className="col s12">
                        <div className="create-account">
                          <h5>
                            New to Collectively?{" "}
                            <Link to="/signup">Create an Account</Link>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </span>
      );
    }
    return (
      <span>
        <div className="container">
          <div className="main-content">
            <Header />
            <div className="section-content center-align login-content">
              <h2>Login to Collectively</h2>
              <div className="row error-message ">
                <form
                  className="col s12 m8 offset-m2  "
                  onSubmit={this.handleSubmit}
                >
                  <div className="col s12">
                    {" "}
                    <span className="show invalid">{failedLoginMessages} </span>
                  </div>
                  <div className="row custom-select">
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="email"
                        label="Username / Email"
                        value={email}
                        error={errors.email}
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="input-field col s12">
                      <TextFieldGroup
                        field="password"
                        label="Password"
                        value={password}
                        error={errors.password}
                        onChange={this.onChange}
                        type="password"
                      />
                      <div className="forgot-psw">
                        <Link to="/reset-password">Forgot Password?</Link>
                      </div>
                    </div>
                    {/* <div className="col s12">
                      <div className="recapcha z-depth-2">
                        {' '}
                        <ReCAPTCHA
                          ref="recaptcha"
                          sitekey={SecretKeys.CaptchKeys}
                          onChange={this.onCatchaChange}
                        />
                        <span className={(errors.captchaError ? 'show invalid' : 'hide')}>{errors.captcha}</span>
                      </div>
                    </div> */}
                    <div className="col s12">
                      <button
                        className="btn waves-effect waves-light primary-btn col s12 m8 offset-m2"
                        type="submit"
                        name="action"
                        disabled={isLoading}
                      >
                        {!isLoading ? "Login" : <CircularProgress size={24} />}
                        <i className="material-icons">arrow_forward</i>
                      </button>
                    </div>
                    <div className="col s12">
                      <div className="create-account">
                        <h5>
                          New to Collectively?{" "}
                          <Link to="/signup">Create an Account</Link>
                        </h5>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

LoginForm.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      requestApiData,
      logoutUser,
      clearDataEmail,
      clearSignupData,
      setPageName
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginForm)
);
